import { Box, FormControl, Stack } from '@mui/material'
import { PreferencesGeneralFormProps } from './_props'
import { admMailProcessSelect, medicalMailProcessSelect } from './_utils'
import PreferencesGeneralFormSelect from './PreferencesGeneralFormSelect'

const PreferencesGeneralForm = ({
    medicalMailProcess,
    handleMedicalProcessChange,
    admMailProcess,
    handleAdmProcessChange,
}: PreferencesGeneralFormProps) => {
    return (
        <Stack direction="column" spacing={3} marginTop="1rem">
            <Box flex={1}>
                <FormControl variant="standard">
                    <PreferencesGeneralFormSelect
                        id="medicalMailProcess"
                        name="medicalMailProcess"
                        tooltipTitle="Choisissez la destination des documents médicaux pour votre établissement. Dans tous les cas, les documents ne seront pas directement accessible, vous devrez vous munir du code de sécurité disponible sur l'application mobile effecteur."
                        value={medicalMailProcess}
                        label="Envoi des documents médicaux"
                        options={medicalMailProcessSelect}
                        onChange={handleMedicalProcessChange}
                    />
                </FormControl>
            </Box>
            <Box flex={1}>
                <FormControl variant="standard">
                    <PreferencesGeneralFormSelect
                        id="admMailProcess"
                        name="admMailProcess"
                        tooltipTitle="Choisissez la destination des documents administratifs pour votre établissement."
                        label="Envoi des documents administratifs"
                        value={admMailProcess}
                        options={admMailProcessSelect}
                        onChange={handleAdmProcessChange}
                    />
                </FormControl>
            </Box>
        </Stack>
    )
}

export default PreferencesGeneralForm
